import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ShowMore from './ShowMore';
import ShowFewer from './ShowFewer';

import { Button } from '../button';

const Toggle = styled(Button)`
    padding: 0;
`;

class ExpandableList extends React.PureComponent {
    static propTypes = {
        defaultOpen: PropTypes.bool,
        previewLength: PropTypes.number,
        maxLength: PropTypes.number,
    };

    static defaultProps = {
        defaultOpen: false,
        previewLength: 3,
        maxLength: 5,
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: props.defaultOpen,
        };
    }

    render() {
        const {
            children,
            previewLength,
            maxLength,
            props,
        } = this.props;

        const content = React.Children.toArray(children).reduce((result, child) => {
            switch (child.type) {
                case ShowMore:
                    result.showMore = child;
                    break;
                case ShowFewer:
                    result.showFewer = child;
                    break;
                default:
                    result.items.push(child);
            }
            return result;
        }, { items: [] });

        const displayedItems = content.items.length <= maxLength || this.state.isOpen ?
            content.items : content.items.slice(0, previewLength);

        return (
            <ul {...props}>
                {displayedItems}
                {this.maybeRenderShowMore(content)}
                {this.maybeRenderShowFewer(content)}
            </ul>
        );
    }

    maybeRenderShowMore(content) {
        if (content.items.length > this.props.maxLength && !this.state.isOpen) {
            return (
                <li>
                    <Toggle
                        onClick={this.showMore}
                        style={Button.STYLE.LINK}
                    >{content.showMore}
                    </Toggle>
                </li>
            );
        }
    }

    maybeRenderShowFewer(content) {
        if (this.state.isOpen) {
            return (
                <li>
                    <Toggle
                        onClick={this.showFewer}
                        style={Button.STYLE.LINK}
                    >{content.showFewer}
                    </Toggle>
                </li>
            );
        }
    }

    showMore = () => this.setState({ isOpen: true })
    showFewer = () => this.setState({ isOpen: false })
}

export {
    ExpandableList as default,
    ExpandableList,
};
